import { NormalInfoWrapper } from "../../../tasks/styles";

type FinancialPsd2Props = {
  data: any;
}

interface Detail {
  label: string;
  value: any;
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1;
  let secondLastValidRow = -1;
  let validCount = 0;

  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      secondLastValidRow = lastValidRow;
      lastValidRow = i;
      validCount++;
    }
  }

  return validCount % 2 === 0
    ? [secondLastValidRow, lastValidRow]
    : [lastValidRow];
}

export const FinancialPsd2Row = ({ data }: FinancialPsd2Props) => {
  // Spain (ES) uses statistica psd2 variables for Financial Details (PSD2)
  const psd2Vars = data?.integrations?.statistica?.psd2?.variables;
  
  // Format monetary values for Spain
  const formatAmount = (amount: number | null | undefined) => amount != null ? `${new Intl.NumberFormat('es-ES').format(amount)} €` : null;
  
  const totalEstimatedIncome = formatAmount(psd2Vars?.EI);
  const totalExpenses = formatAmount(psd2Vars?.Expenses);
  const affordabilityPsd2 = psd2Vars?.Affordability_PSD2;
  const dtiPsd2 = psd2Vars?.DTI;

  const financialDetails = [
    { label: 'Total Estimated Income (EI)', value: totalEstimatedIncome },
    { label: 'Total Expenses', value: totalExpenses },
    { label: 'Affordability (PSD2)', value: affordabilityPsd2 },
    { label: 'DTI', value: dtiPsd2 },
  ];

  const lastIndexes = getIndexOfLastRow(financialDetails);

  const isEmpty = financialDetails.every(
    (detail) => detail.value === null || detail.value === undefined,
  );
  if (isEmpty) return null;
  return (
    <>
      <NormalInfoWrapper $header>Financial Details (PSD2)</NormalInfoWrapper>
      {financialDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return;
        return (
          <NormalInfoWrapper
            key={`financial-psd2-${index}-${detail.label}`}
            $isLast={lastIndexes.includes(index)}
          >
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        );
      })}
    </>
  );
};
